import { Barcode } from 'lucide-react';

import { FieldRegistry } from '../FieldRegistry';

FieldRegistry.register({
  type: 'barcode',
  renderInput: ({ value, onChange }) => {
    const val = (value as string) ?? '';
    return (
      <div className="space-y-3">
        <input
          type="text"
          value={val}
          onChange={(e) => onChange(e.target.value || null)}
          className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-1.5 font-mono text-sm text-text-primary placeholder:text-text-tertiary focus:border-accent-500 focus:ring-1 focus:ring-accent-500 focus:outline-none"
          placeholder="Wprowadź kod kreskowy…"
          maxLength={50}
        />
        {val && (
          <div className="flex flex-col items-center gap-2 rounded-lg border-2 border-border-secondary bg-bg-primary p-4">
            {/* Uproszczona wizualizacja kodu kreskowego */}
            <div className="flex h-14 items-end gap-px bg-bg-primary p-1">
              {Array.from(val).map((char, i) => {
                const h = 32 + (char.charCodeAt(0) % 24);
                return <div key={i} className="w-1 bg-text-primary" style={{ height: `${h}px` }} />;
              })}
            </div>
            <span className="font-mono text-sm text-text-secondary">{val}</span>
          </div>
        )}
      </div>
    );
  },
  renderCell: (_field, value) => {
    if (!value) return '—';
    return (
      <div className="flex items-center gap-2">
        <Barcode className="h-3.5 w-3.5 flex-shrink-0 text-text-muted" />
        <code className="font-mono text-xs text-text-primary">{String(value)}</code>
      </div>
    );
  },
  validate: (value, field) => {
    if (!value) return field.isRequired ? 'Pole wymagane' : null;
    if (!/^[A-Z0-9]+$/i.test(String(value)))
      return 'Kod kreskowy może zawierać tylko litery i cyfry';
    const rules = (field.validationRules ?? {}) as Record<string, unknown>;
    const len = String(value).length;
    if (rules['minLength'] && len < Number(rules['minLength']))
      return `Minimum ${rules['minLength']} znaków`;
    if (rules['maxLength'] && len > Number(rules['maxLength']))
      return `Maksimum ${rules['maxLength']} znaków`;
    return null;
  },
  defaultValue: null,
});
